import PropTypes from 'prop-types'
import { Nav } from 'react-bootstrap'

const TabNavItem = ({ condition, eventKey, setEventKey, title }) => (
  <If condition={condition}>
    <Nav.Item>
      <div className='desktop-scroll-target' id={`scroll-target-${eventKey}`} />
      <Nav.Link
        className='custom-style'
        eventKey={eventKey}
        onClick={() => setEventKey(eventKey)}
      >
        {title}
      </Nav.Link>
    </Nav.Item>
  </If>
  )

export default TabNavItem

TabNavItem.propTypes = {
  condition: PropTypes.bool.isRequired,
  eventKey: PropTypes.string.isRequired,
  setEventKey: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}
